// Export component settings.
export const settings = {
  selector: '.js-property-search-results',
  tabsSelector: '.js-property-search-results-tabs',
  buttonListSelector: '.js-list',
  buttonMapSelector: '.js-map',
  resultsSelector: '.js-property-search-results-results',
  mapSelector: '.js-property-search-results-map',
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
function init( element ) {
  let tabs = element.querySelector( settings.tabsSelector )
  let listButton = tabs.querySelector( settings.buttonListSelector )
  let mapButton = tabs.querySelector( settings.buttonMapSelector )

  let results = element.querySelector( settings.resultsSelector )
  let map = element.querySelector( settings.mapSelector )

  listButton.addEventListener( 'click', ( e ) => {
    results.style.display = 'grid'
    map.style.display = 'none'
    e.target.classList.add( 'active' )
    mapButton.classList.remove( 'active' )
  })

  mapButton.addEventListener( 'click', ( e ) => {
    results.style.display = 'none'
    map.style.display = 'block'
    e.target.classList.add( 'active' )
    listButton.classList.remove( 'active' )
  })

  listButton.click()
}
